"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Share;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Share(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "share"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline-4",
    "data-name": "outline",
    d: "M69.428,65.581a12.138,12.138,0,0,0-7.512,2.6,2.449,2.449,0,0,0-.443-.45L42.817,53.472a2.468,2.468,0,0,0-.471-.28,11.9,11.9,0,0,0,0-6.387,2.512,2.512,0,0,0,.472-.277L61.473,32.271a2.449,2.449,0,0,0,.443-.45,12.173,12.173,0,1,0-3.174-3.71,2.478,2.478,0,0,0-.3.188L40.069,42.335a12.21,12.21,0,1,0,0,15.33L58.437,71.7a2.359,2.359,0,0,0,.3.193,12.209,12.209,0,1,0,10.69-6.313Zm0-50.581a7.21,7.21,0,1,1-7.21,7.21A7.218,7.218,0,0,1,69.428,15ZM30.572,57.21A7.21,7.21,0,1,1,37.782,50,7.219,7.219,0,0,1,30.572,57.21ZM69.428,85a7.21,7.21,0,1,1,7.21-7.21A7.218,7.218,0,0,1,69.428,85Z"
  }))));
}